var Pages = require('pagemodules/__init__');

(function(){



  $(function(){
    Pages.init();
  });
})();









//////////////////
// WEBPACK FOOTER
// ./htdocs_dev/_script/app.js
// module id = 0
// module chunks = 0